<p>{{ countdownMessage() }}</p>
